import axios from 'axios'
import auth from "@/auth/authService";

export default class BeSimpleAPI {
    // Constructor
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    all(resource, queryParameters) {
        var query = '';

        if(queryParameters){
            query += '?';

            queryParameters.forEach(element => {
                query += element.key + '=' + element.value + '&';
            });

            query = query.slice(0, -1);
        }

        return http(this.baseUrl).then((http) => { return http.get(`${resource}${queryParameters ? query : ''}`) })
    }
    find(resource, id) {
        return http(this.baseUrl).then((http) => { return http.get(`${resource}/${id}`) })
    }
    create(resource, params) {
        return http(this.baseUrl).then((http) => { return http.post(`${resource}`, params) })
    }
    update(resource, params) {
        return http(this.baseUrl).then((http) => { return http.put(`${resource}/${params.id}`, params) })
    }
    delete(resource, id) {
        return http(this.baseUrl).then((http) => { return http.delete(`${resource}/${id}`) })
    }
    search(query) {
        return http(this.baseUrl).then((http) => { return http.get(query) })
    }
    download(resource) {
        return http(this.baseUrl).then((http) => { return http.get(resource, { responseType: 'blob' }) })
    }
    execute(resource, id, action, params) {
        return http(this.baseUrl).then((http) => { return http.post(`${resource}/${id}/${action}`, params) })
    }
    excuteCommand(resource,params){
        return http(this.baseUrl).then((http) => { return http.post(resource, params) })
    }
    getImage(resource,filename){
        return http(this.baseUrl).then((http) => { return http.get(`${resource}?filename=${filename}`, { responseType: 'arraybuffer' }) }).then(response => {
            return Buffer(response.data, 'binary').toString('base64');
        })
    }
}
function http(baseUrl) {
    return auth.getAccessToken()
    .then((accessToken) => {
    return axios.create({
        baseURL: baseUrl,
        timeout: 300000,
        headers: {
            'Access-Control-Allow-Origin': '*',
                'Authorization': `Bearer ${accessToken}`
        }
        })
    })
}